import { useCallback, useRef } from "react";

interface Payload {
  upload_url: string;
  fileBlob: Blob;
}

const useUploadFileToS3Query = () => {
  const controllerRef = useRef(new AbortController());

  const uploadFileToS3 = useCallback(async ({ upload_url, fileBlob }: Payload) => {
    controllerRef.current = new AbortController();
    const response = await fetch(upload_url, {
      method: 'PUT',
      headers: { 'x-amz-acl': 'private' },
      body: fileBlob,
      signal: controllerRef.current.signal,
    });
    return response;
  }, []);

  const cancelUploadToS3 = useCallback(() => {
    controllerRef.current.abort();
  }, []);

  return {
    uploadFileToS3,
    cancelUploadToS3,
  };
};

export default useUploadFileToS3Query;
